import { InstallationEntityModel } from "src/store/models/entity/installation/entity";
import {  InstallationHelperModel } from "src/store/models/entity/installation/helper";

export const encooInstallationModels = {
  entity: InstallationEntityModel,
  helper: InstallationHelperModel,
};
